module.exports = __webpack_public_path__ + "dimer/static/img/project1.2ad6711.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project1.jpg
// module id = nt0z
// module chunks = 0